import * as types from './types';
import createReducer from '../reducers';

const initialState = {
  data: [],
  meta: {},
  loading: false,
  error: null,
};
const success = (state, { payload }) => ({
  ...state,
  data: payload.data,
  meta: payload.meta,
  loading: false,
});

const request = (state, { payload }) => ({
  ...state,
  loading: payload
});

const error = (state, { payload }) => ({
  ...state,
  error: payload,
  loading: false,
});

const update = (state, { payload }) => {
  const { data } = state;
  const newData = data.map(item => {
    return item.id === payload.id ? payload : item
  });
  
  return {
    ...state,
    data: newData
  }
};

export default createReducer(initialState, {
  [types.REQUEST]: request,
  [types.SUCCESS]: success,
  [types.ERROR]: error,
  [types.UPDATE]: update,
});


// WEBPACK FOOTER //
// ./src/store/customers/reducer.js